(function() {
  const lacesVariantsArray = document.querySelectorAll('.product__variantsSwatchesList p');
  const swatchVariant = document.querySelector('.product__variantsSwatchesHeader span');

  function toggleVariant(event) {
    const currentVariant = event.currentTarget;
    const currentWrapper = currentVariant.closest('.product__variantsSwatchesList');
    const activeVariant = currentWrapper.querySelector('.product__variantsSwatchesListItems--active');

    if (currentVariant.classList.contains('.product__variantsSwatchesListItems--active')) {
      return
    } else {
      const variantLabel = document.querySelector(`.product__swatchesItemLabel label[data-size="${currentVariant.dataset.variant}"]`);

      activeVariant.classList.remove('product__variantsSwatchesListItems--active');
      currentVariant.classList.add('product__variantsSwatchesListItems--active');

      variantLabel.click();

      if (swatchVariant) {
        toggleSwatchHeader();
      }
    }
  }

  function toggleSwatchHeader() {
    let activeVariant = document.querySelector('.selected-swatch');

    swatchVariant.innerText = activeVariant.dataset.option;
  }

  if (swatchVariant) {
    toggleSwatchHeader();
  }

  lacesVariantsArray.forEach(variant => {
    variant.addEventListener('click', (event) => {
      toggleVariant(event);
    });
  });
})();
